import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import axios from '@/services'
import useActions from '@/composables/actions/useActions.js'
import axiosInstance from '@/services'
import use714Actions from '@/composables/actions/use714Actions'
import { DateTime } from 'luxon'
import { default as lookups } from '@/assets/json/clientLookups.json'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

async function verifyRequestNumber() {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()
  const { serviceTransactionId } = globalStore.startedService

  const { referenceRequestNumber, personUnifiedNumber, nominationEmail } =
    formStore.form.values || {}
  const { requestNumber } = formStore.draft?.request || {}
  if (!nominationEmail && !referenceRequestNumber) {
    return
  }
  const params = {
    serviceTransactionId: serviceTransactionId,
    requestNumber: referenceRequestNumber,
    emailAddress: nominationEmail,
    unifiedNumber: personUnifiedNumber || '',
    serviceRequestNumber: requestNumber || ''
  }

  const data = await axios.get(
    '/api/NominationGoldenVisa/draft/checkIfEligableForNominationRequest',
    { params }
  )

  if ('errorMessage' in data) {
    formStore.form.setValues({
      referenceRequestNumber: null,
      nominationEmail: null
    })
    formStore.extraMap.isNominationRequestValid = false
    throw data.errorMessage
  }

  /**
   * TODO: what happens when there's a nomination request?
   * answer:
   * web/client/typingCenter/pages/visa/visaRequest.step1Ctrl.js
   * $scope.checkNominationRequestNumber = function
   * auto-fill fields and disable
   */
  formStore.extraMap.isNominationRequestValid = true
  return data
}

async function fetchDraftByRequestNumber(draftNumber) {
  if (!draftNumber) {
    return
  }
  const formStore = useFormStore()
  const { referenceRequestNumber } = formStore.form.values
  let approve = false

  const checkRequestStatus = async () => {
    const result = await axiosInstance.get(
      `/api/typingCenter/request/search/${referenceRequestNumber}`
    )
    if (result?.collection?.[0]?.requestAction?.id == 6) {
      approve = true
    }
  }

  const checkIfHasRelatedRequests = async () => {
    const path = `/api/requestmaster/${referenceRequestNumber}/relatedRequests`
    const requestList = await axiosInstance.get(path)

    const { requestTransactionTypeId, rejectLookupLastActionId } = lookups
    let isValidRequest = true
    requestList.map((requestItem) => {
      const { transactionType, lastActionId } = requestItem
      if (
        transactionType.id == requestTransactionTypeId &&
        !rejectLookupLastActionId.some((e) => e === lastActionId)
      ) {
        formStore.form.setFieldValue('referenceRequestNumber', '')
        notify(
          {
            group: 'error',
            title: 'Error',
            text: i18n.global.t('referanceRequestNumberUsed')
          },
          6000
        )
        isValidRequest = false
      }
    })
    return isValidRequest
  }

  const loadDrafInfoFromDraftNumber = async () => {
    const result = await axiosInstance.get(
      `/api/typingCenter/residency/draft/requestNumber/${draftNumber}`
    )
    if (result && approve) {
      //TODO formStore.form.setValues(result); but on their source code is using $parent.draft not draft.request?
    } else {
      notify(
        {
          group: 'error',
          title: 'Error',
          text: i18n.global.t('empty')
        },
        6000
      )
    }
  }

  const isValid = await checkIfHasRelatedRequests()
  if (isValid) {
    await checkRequestStatus()
    await loadDrafInfoFromDraftNumber()
  }
}
async function fetchRequestRecord(draftNumber) {
  const formStore = useFormStore()

  const param = draftNumber || formStore.form.values.referenceRequestNumber

  const path = `/api/establishment/residency/draft/requestNumber/${param}`
  const data = await axiosInstance.get(path)

  formStore.draft =
    Object.keys(formStore.draft || {}).length > 0 ? formStore.draft : { request: {} }

  formStore.draft = data

  Object.assign(formStore.draft.request, {
    fileNo: 'test file no',
    identityNumber: 'test file identityNumber',
    sponsorDepartment: {
      text: 'test sponsorDepartment'
    },
    sponsorNumber: 'test sponsorNumber',
    sponsorEnglishName: 'test sponsorEnglishName',
    sponsorArabicName: 'test sponsorArabicName',
    sponsorDepartmenNew: {
      text: 'test sponsorDepartmenNew'
    },
    sponsorNumberNew: 'test sponsorNumberNew',
    sponsorEnglishNameNew: 'test sponsorEnglishNameNew',
    sponsorArabicNameNew: 'test sponsorArabicNameNew',
    englishName: 'test englishName',
    arabicName: 'test arabicName',
    motherName: 'test motherName',
    maritalStatus: {
      text: 'test maritalStatus'
    },
    currentNationality: { text: 'test currentNationality' },
    previousNationality: { text: 'test previousNationality' },
    dateOfBirth: 'test dateOfBirth',
    countryOfBirth: { text: 'test countryOfBirth' },
    birthCity: 'test birthCity',
    gender: { text: 'test gender' },
    religion: { text: 'test religion' },
    faith: { text: 'test faith' },
    profession: { text: 'test profession' },
    educationLevel: { text: 'test educationLevel' },
    numberOfYears: 'test numberOfYears',
    passportNumber: 'test passportNumber',
    passportType: { text: 'test passportType' },
    passportCountry: { text: 'test passportCountry' },
    passportArabicIssuePlace: 'test passportArabicIssuePlace',
    passportIssueDate: 'test passportIssueDate',
    passportExpiryDate: 'test passportExpiryDate',
    localAddress: { name: 'test localAddress' },
    buildingName: 'test buildingName',
    localPobox: 'test localPobox',
    uaePhoneNumber: 'test uaePhoneNumber',
    localWorkPhone: 'test localWorkPhone',
    localMobile: 'test localMobile',
    abroadCountry: { text: 'test abroadCountry' },
    abroadAddress: { name: 'test abroadAddress' },
    abroadPhone: 'test abroadPhone',
    ...data
  })

  formStore.form.setValues(formStore.draft.request)

  return Promise.resolve('hi')
}
async function checkEntryExit() {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  formStore.form.setTouched(true)
  const validationResult = await formStore.form.validate()
  if (!validationResult.valid && !globalStore.showcase.skipValidation) {
    const messages = Object.entries(formStore.form.errors)
      .filter(([key, value]) => key.indexOf('edit_') < 0)
      .map(([key, value]) => `${key}: ${value}`)
      .join('<br/>')
    notify(
      {
        group: 'error',
        title: 'error',
        text: messages
      },
      6000
    )
    if (messages?.length > 0) {
      return
    }
  }
  const { myTransactionSelected, startDate = '', endDate = '' } = formStore.form.values
  if (myTransactionSelected) {
    const params = {
      canceledSponsoredFlag: 0,
      currentPage: 1,
      pageSize: 10,
      myTransactions: myTransactionSelected,
      sponsoredUnifiedNumber: 0,
      endDate: DateTime.fromFormat(endDate, 'dd/MM/yyyy').toFormat('yyyy/MM/dd'),
      startDate: DateTime.fromFormat(startDate, 'dd/MM/yyyy').toFormat('yyyy/MM/dd')
    }
    const res = await axios.post('/api/individual/EntryExit', { ...params })
    if (res) {
      const { collection = [] } = res || {}
      formStore.draft.request = {
        ...formStore.draft.request,
        collection
      }
      formStore.form.setValues({
        collection
      })
    }
  }
}

async function getAllRegisteredShips() {
  const formStore = useFormStore()
  const { shipNumberForSearch, nationalityIdForSearch } = formStore.form.values
  const path = `/api/seaPort/ship/getAllRegisteredShips/${shipNumberForSearch}/${nationalityIdForSearch}`
  const registeredShips = await axios.get(path)

  Object.assign(formStore.extraMap, {
    showShipsTable: true,
    registeredShips
  })
}

async function checkVisaOnArrival() {
  const formStore = useFormStore()
  const {
    passportNumber = '',
    passportTypeId = '',
    dateOfBirth = '',
    currentNationalityId = ''
  } = formStore.form.values
  if (!passportNumber || !passportTypeId || !dateOfBirth || !currentNationalityId) return
  const path = `/api/typingCenter/request/validateVisaOnArrival`
  const res = await axios.get(path, {
    params: {
      passportNumber,
      passportTypeId,
      dateOfBirth,
      currentNationalityId
    }
  })
  if (!res) {
    formStore.extraMap.showVisaOnArrivalWarningMessage = true
    formStore.draft.request = {
      ...formStore.draft.request,
      passportNumber: '',
      dateOfBirth: '',
      passportTypeId: ''
    }
    return
  }
  formStore.extraMap.administrativeRegionId = res.administrativeRegionId
  formStore.draft.request = {
    ...formStore.draft.request,
    ...res
  }
  canExtendVisa()
}

async function canExtendVisa() {
  const formStore = useFormStore()
  const {
    serviceYear = '',
    serviceCode = '',
    sequenceNumber = '',
    departmentCode = '',
    passportTypeId = '',
    passportNumber = '',
    dateOfBirth = '',
    currentNationalityId = ''
  } = formStore.form.values
  const path = `/api/guest/visa/canExtendVisa`
  const res = await axios.get(path, {
    params: {
      serviceYear,
      serviceCode,
      sequenceNumber,
      departmentCode,
      passportTypeId,
      passportNumber,
      dateOfBirth,
      currentNationalityId,
      serviceTransactionId: formStore.extraMap
    }
  })
  if (!res) return
  if (!response.isSuccess) {
    notify(
      {
        group: 'error',
        title: 'Error',
        text: response.errorCode
      },
      6000
    )
    formStore.draft.request = {
      ...formStore.draft.request,
      englishName: '',
      arabicName: '',
      personUnifiedNumber: '',
      departmentCode: '',
      serviceYear: '',
      serviceCode: '',
      sequenceNumber: ''
    }
    return
  }
}
export default function () {
  return {
    verifyRequestNumber,
    finesSearch: () => {
      useActions('finesSearch')
    },
    readDataFromCard: () => {
      useActions('readDataFromCard')
    },
    retriveVisaInformation: () => {
      useActions('retriveVisaInformation')
    },
    bookAnAppointment: () => {
      useActions('bookAnAppointment')
    },
    checkNominationRequestNumber: () => {
      useActions('checkNominationRequestNumber')
    },
    checkPermitLeaveEligibility: () => {
      useActions('checkPermitLeaveEligibility')
    },
    fetchRequestRecord,
    fetchDraftByRequestNumber,
    requestChangeMobileOTP: () => use714Actions('requestChangeMobileOTP'),
    checkRequestChangeMobileOTP: () => use714Actions('checkRequestChangeMobileOTP'),
    sendOtpEmail: () => use714Actions('sendOtpEmail'),
    checkOtpEmail: () => use714Actions('checkOtpEmail'),
    getAvailableInitialApprovalRequests: () => {
      useActions('getAvailableInitialApprovalRequests')
    },
    checkEntryExit,
    getAllRegisteredShips,
    checkVisaOnArrival
  }
}
